// eslint-disable-next-line
import { versions } from "./util/constants";

export const clickTravelThreshold = 5; //pixels
export const angleSensitivityPxPerDegree = 2;
export const markerSize = [16, 16];

export const toolbarHeightPx = 64;

export const exampleSpinOptions = [
  {
    src: "https://hotspot-wizard.sirv.com/Spins/PinkBoot/pink-boot-01.jpg?w=160",
    url: "https://hotspot-wizard.sirv.com/Spins/PinkBoot/PinkBoot.spin",
  },
  {
    src: "https://hotspot-wizard.sirv.com/Spins/Magnos/MAGNOS-01.jpg?w=160",
    url: "https://hotspot-wizard.sirv.com/Spins/Magnos/Magnos.spin",
  },
  {
    src: "https://hotspot-wizard.sirv.com/Spins/Stroller/IMG_999_690.jpg?w=160",
    url: "https://hotspot-wizard.sirv.com/Spins/Stroller/Stroller.spin",
  },
];

export const exampleImageOptions = [
  {
    src: "https://demo.sirv.com/ecohome.jpg?w=160",
    url: "https://demo.sirv.com/ecohome.jpg",
  },
  {
    src: "https://demo.sirv.com/trainer.jpg?w=160",
    url: "https://demo.sirv.com/trainer.jpg",
  },
  {
    src: "https://demo.sirv.com/living-room.jpg?w=160",
    url: "https://demo.sirv.com/living-room.jpg",
  },
];

export const iconSize = 14.67; //px
export const iconSizeBigger = 16; //px
export const hotspotSize = [20, 20]; //in px, default taken from actual size in current sirv stylesheet
export const offFrameHotspotSize = [6, 6];
export const colorDisabled = "rgba(0,0,0,0.38)";
export const notificationDuration = 1000; //ms
export const dragToSpinHintTransitionDurationMs = 240;
export const demonstrateHotspotPathAnimationDurationMs = 800;
export const thumbnailScale = 0.6;

export const allowedParentOrigins = [
  "https://tools.sirv.com",
  "https://my.sirv.com",
  "http://localhost:3000",
  "http://my.sirv.localhost",
  "https://my.sirv.localhost",
];
export const debug = {
  // isEmbedded: true,
  // url: "https://hotspot-wizard.sirv.com/Spins/Egg-Chair/Egg-Chair-test-tooltip-style-application.spin",
  // version: versions.image,
};

export const locationModeHotspotClickBehavior = "toggle"; // 'hybrid'|'toggle'
export const useSirvMediaViewerDefaultStylesIfPointerVarianIsEqualTo =
  "default";

export const useSirvMediaViewerDefaultStylesIfBoxVarianIsEqualTo = "default";

export const pruneKeyframesDefaultTargetCount = 8;

export const imageRetryQuota = 100;
export const imageRetryQuotaDecrement = 25;
export const imageRetryDelay = 2000; //ms
